/*eslint-disable*/
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const FB_APP_ID = config.public.fbAppId

  if (!FB_APP_ID) {
    return
  }

  const vueFB = {}

  // Load Facebook SDK
  ;(function (d, s, id) {
    let js = d.getElementsByTagName(s)[0]
    const fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) {
      return
    }
    js = d.createElement(s)
    js.id = id
    js.src = '//connect.facebook.net/en_US/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
  })(document, 'script', 'facebook-jssdk')

  window.fbAsyncInit = function onSDKInit() {
    FB.init({
      appId: FB_APP_ID,
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v4.0',
    })
    // 在 pixel 上會記錄到 null 事件，故先註解
    // FB.AppEvents.logPageView()
    window.FB = FB
    window.dispatchEvent(new Event('fb-sdk-ready'))
    vueFB.sdk = FB
  }

  return {
    provide: {
      fbSDK: vueFB,
    },
  }
})
